module.exports = {"type":"routeLabel","data":{"type":"Feature","geometry":{"type":"Point","coordinates":[]},"properties":{"style":{"color":"#333","fill":false,"opacity":1},"label":""}}}


//////////////////
// WEBPACK FOOTER
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/transform/geojson/mission/route/lib/routeLabel.json
// module id = 430
// module chunks = 0